import { getApiInstance, getOAuthToken } from './ApiToken'

export default {
  async getMarketSessions (params) {
    const api = await getApiInstance()
    try {
      const response = api.get('marketSession', { params })
      return response
    } catch (error) {
      if (error.response && error.response.status === 401) {
        getOAuthToken()
        const api = getApiInstance()
        const response = api.get('marketSession', { params })
        return response
      }
      throw error
    }
  },

  save (form) {
    const api = getApiInstance()
    try {
      const response = api.post('marketSession', form)
      return response
    } catch (error) {
      if (error.response && error.response.status === 401) {
        getOAuthToken()
        const api = getApiInstance()
        const response = api.post('marketSession', form)
        return response
      }
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/MarketSessionsService.js